import { IGetInProcessCheckDetailRequest, IInProcessCheckDetail } from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";
const prefix = PREFIX.inProcessCheckDetail;

class InProcessCheckDetailApiService extends BaseApiService {
  public getAllInProcessCheckDetail = (
    request: IGetInProcessCheckDetailRequest
  ) =>
    this.get<IInProcessCheckDetail>(`${prefix}`, {
      params: request,
    });
  public getInProcessCheckDetailById = (id: string) =>
    this.get<IInProcessCheckDetail>(`${prefix}/${id}`);
  public createInProcessCheckDetail = (
    request: Partial<IInProcessCheckDetail>
  ) =>
    this.post<Partial<IInProcessCheckDetail>, IInProcessCheckDetail>(
      `${prefix}`,
      request
    );
  public updateInProcessCheckDetail = (request: IInProcessCheckDetail) =>
    this.put<IInProcessCheckDetail, IInProcessCheckDetail>(
      `${prefix}`,
      request
    );
  public deleteInProcessCheckDetail = (id: string) =>
    this.delete<string>(`${prefix}/${id}`);
}

export default new InProcessCheckDetailApiService();
